import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ControlsSkipNextIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M15.86 11.96L4.94 18.76V5.16L15.86 11.96ZM18.88 18.6H17.12V5.32H18.88V18.6ZM6.6 8.26V15.68L12.72 11.96L6.6 8.26Z" />
    </SvgIcon>
  );
});
